module.exports = __webpack_public_path__ + "static/media/13.62dede2c.jpeg";